import { Component } from '@angular/core';

@Component({
  selector: 'lib-tab-selector',
  templateUrl: './tab-selector.component.html',
  styleUrls: ['./tab-selector.component.scss'],
})
export class TabSelectorComponent {}
